// extracted by mini-css-extract-plugin
module.exports = {"slotWrapper":"ConnectedDoctorSlots-module__slotWrapper___2Hqh4"};